<template>
  <div id="app">
    <!-- <MyHead @changeMenu='changeMenu'/> -->
    <layout :menuId ='menuId'></layout>
  </div>
</template>

<script>
import layout from './views/Layout.vue'
import MyHead from './components/myHead.vue'
export default {
  components: {
    layout,
    MyHead
  },
  created(){
  const isDesktop = window.innerWidth >= 1400; // 假设电脑端屏幕宽度大于等于 1400px
  if (!isDesktop) {
    const designWidth = 1400; // 设计稿的宽度，例如 1400px
    const scale = document.documentElement.clientWidth / designWidth;
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', `width=${designWidth}, initial-scale=${scale}, user-scalable=yes,target-densitydpi=device-dpi`);
     console.log('缩放',viewport)
   }
  }
  },
  data(){
    return {
      menuId:1
    }
  },
  methods:{
    changeMenu(val){
      console.log(val);
      this.menuId=val
    }
  }
};
</script>
<style lang="scss">
  /* 避免纵向滚动条占用宽度导致整块内容视觉上“偏左”、右侧贴边 */
  html {
    scrollbar-gutter: stable;
  }

   #app{
   width: 100%;
    // height: 100%;
   }
  .el-message{
     height: 100px !important;

    .el-message__content{
      font-size: 20px!important;
    }
    .el-icon-error{
      font-size: 20px !important;
    }
   }

</style>
